import {
  baseUniDriverFactory /* findByHook */,
} from '../test-utils/utils/unidriver';
// import { dataHooks } from './constants';

export const sparklineChartDriverFactory = (base, body) => {
  return {
    ...baseUniDriverFactory(base, body),
  };
};
